package com.gloopgo.game.viewmodel

import com.gloopgo.game.engine.GameConstants
import com.gloopgo.game.engine.GameState

/**
 * UI State representing the state of the active gameplay session.
 */
data class GameUiState(
    val gameState: GameState = GameState(localPlayer = null),
    val playerId: String = "",
    val playerName: String = "",
    val roomId: String = GameConstants.DEFAULT_ROOM_ID,
    val isAuthenticated: Boolean = false,
    val isConnecting: Boolean = false,
    val isElder: Boolean = false,
    val finalMass: Int = 0,
    val rank: Int = 1,
    val pelletsEaten: Int = 0,
    val isPaused: Boolean = false,
    val errorMessage: String? = null
)
